import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    light: {
        width: 14,
        height: 14,
        borderRadius: '50%',
        marginRight: 8,
        display: 'inline-block',
    },
    connected: {
        backgroundColor: '#00bcd4',
    },
    disconnected: {
        animation: '$blink 1s infinite',
    },
    '@keyframes blink': {
        '0%': { backgroundColor: '#ffee58' },
        '50%': { backgroundColor: '#00bcd4' },
        '100%': { backgroundColor: '#ffee58' },
    },
});

export const ScannerStatusIndicator = ({ connected }) => {
    const classes = useStyles();
    return (
        <Box
            className={`${classes.light} ${
                connected ? classes.connected : classes.disconnected
            }`}
        />
    );
};
